import { render, staticRenderFns } from "./declaraciones-f1.vue?vue&type=template&id=85148c1a&"
import script from "./declaraciones-f1.component.ts?vue&type=script&lang=ts&"
export * from "./declaraciones-f1.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports